import { IKeyVal } from "../shared/Password";
import PropertyRow from "./PropertyRow";

export default function PropertyList(props:{data:IKeyVal[]}) {
    const list:React.ReactElement[] = props.data.map(data => <PropertyRow key={data.key} data={data}/>)
    return list.length ? <div className="keyvals">{list}</div> : <></>
}